export default "__VITE_ASSET__DycjugXA__"